import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { listAudit } from '../api/quality.js';
import { ApiError } from '../api/client.js';

interface AuditRow {
  readonly auditId?: string;
  readonly action?: string;
  readonly actorUserId?: string;
  readonly createdAt?: string;
  readonly payload?: unknown;
}

export function ReviewAuditPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly AuditRow[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res = (await listAudit(id, token)) as readonly AuditRow[];
      setRows(res);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Load failed');
    } finally { setLoading(false); }
  }, [id, token]);
  useEffect(() => { void load(); }, [load]);

  return (
    <main aria-label="review-audit">
      <h1>Audit — {id}</h1>
      {loading ? <div role="status">Loading…</div> : null}
      {error ? <div role="alert">{error}</div> : null}
      <div aria-label="audit-count">{rows.length} event(s)</div>
      <ol aria-label="audit-list">
        {rows.map((r, i) => (
          <li key={r.auditId ?? i} aria-label={`audit-${i}`}>
            <strong>{r.action ?? 'EVENT'}</strong>
            {' '}— {r.actorUserId ?? '—'} @ {r.createdAt ?? ''}
          </li>
        ))}
      </ol>
    </main>
  );
}
